import m from "mithril";
import Page from "../Page";

export default class PageLanding extends Page {

    public view() {
        const questionary = this.settings.form.questionary;

        return m('.customForm', {}, [
            m("div", {"class": this.settings.formHtmlClass()}, [
                m(".content", {}, [
                    this.viewHeroVideo(),
                    this.viewHeroImage(),
                    m.trust(questionary.renderText(this.settings.form.text))
                ] ),
            ]),
            this.viewControls('letsGetStarted'),
        ]);
    }

}